import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, Navigate, useSearchParams, useLocation } from "react-router-dom";
import "./styles/index.css";
import CinemaMain from "./pages/Main/CinemaMain";
import CameraMain from "./pages/Main/CameraMain";
import Login from "./pages/Auth/Login/Login";
import JoinAgreement from "./pages/Auth/Join/JoinAgreement";
import IdFind from "./pages/Auth/Find/IdFind";
import PassWordFind from "./pages/Auth/Find/PassWordFind";
import JoinVerification from "./pages/Auth/Join/JoinVerification";
import JoinForm from "./pages/Auth/Join/JoinForm";
import JoinUser from "./pages/Auth/Join/JoinUser";
import JoinComplete from "./pages/Auth/Join/JoinComplete";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import FloatingNavigation from "./components/FloatingNavigation/FloatingNavigation";
import PrivacyPolicy from "./pages/About/PrivacyPolicy";
import MainMore from "./pages/More/MainMore";
import SearchPage from "./pages/Search/SearchPage";
import PackageDetail from "./pages/ProductDetail/PackageDetail";
import BrandPage from "./pages/Category/BrandPage";
import BrandPageSec from "./pages/Category/BrandPageSec";
import Purpose from "./pages/Category/PurposePage";
import CinemaPage from "./pages/Category/CinemaPage";
import CinemaPageSec from "./pages/Category/CinemaPageSec";
import CinemaPageSecDetail from "./pages/Category/CinemaPageSecDetail";
import OrderView from "./pages/Order/OrderView";
import VisitOrder from "./pages/Order/VisitOrder";
import ParcelOrder from "./pages/Order/ParcelOrder";
import SaleOrder from "./pages/Order/SaleOrder";
import QuotationForm from "./pages/Order/QuotationForm";
import OrderComplete from "./pages/Order/OrderComplete";
import MyPage from "./pages/MyPage/Shopping/MyPage";
import MyOrderList from "./pages/MyPage/Shopping/MyOrderList";
import OrderManagement from "./pages/MyPage/Shopping/OrderManagement";
import OrderDetail from "./pages/MyPage/Shopping/OrderDetail";
import OrderExtension from "./pages/MyPage/Shopping/OrderExtension";
import OrderExchangeDetail from "./pages/MyPage/Shopping/OrderExchangeDetail";
import OrderReturnDetail from "./pages/MyPage/Shopping/OrderReturnDetail";
import OrderReturnForm from "./pages/MyPage/Shopping/OrderReturnForm";
import OrderExchangeForm from "./pages/MyPage/Shopping/OrderExchangeForm";
import DepositAndPointList from "./pages/MyPage/Shopping/DepositAndPointList";
import DepositCharge from "./pages/MyPage/Shopping/DepositCharge";
import DepositRefund from "./pages/MyPage/Shopping/DepositRefund";
import CouponList from "./pages/MyPage/Shopping/CouponList";
import WishList from "./pages/MyPage/Shopping/WishList";
import InquiryList from "./pages/MyPage/Inquiry/InquiryList";
import InquiryDetail from "./pages/MyPage/Inquiry/InquiryDetail";
import DeliveryAddrList from "./pages/MyPage/Account/DeliveryAddrList";
import RegisterDeliveryAddr from "./pages/MyPage/Account/RegisterDeliveryAddr";
import EditProfile from "./pages/MyPage/Account/EditProfile";
import Community from "./pages/Community/Community";
import NoticeList from "./pages/Community/NoticeList";
import NoticeDetail from "./pages/Community/NoticeDetail";
import EventList from "./pages/Community/EventList";
import FaqList from "./pages/Community/FaqList";
import CommInquiryList from "./pages/Community/CommInquiryList";
import CommInquiryForm from "./pages/Community/CommInquiryForm";
import CommInquiryDetail from "./pages/Community/CommInquiryDetail";
import CustomizingList from "./pages/Community/CustomizingList";
import CustomizingForm from "./pages/Community/CustomizingForm";
import CustomizingDetail from "./pages/Community/CustomizingDetail";
import SupportList from "./pages/Community/SupportList";
import SupportForm from "./pages/Community/SupportForm";
import PriceGuarantee from "./pages/Community/PriceGuarantee";
import PriceGuaranteeForm from "./pages/Community/PriceGuaranteeForm";
import CreditList from "./pages/Community/CreditList";
import About from "./pages/About/About";
import CompanyIntro from "./pages/About/CompanyIntro";
import CompanyHistory from "./pages/About/CompanyHistory";
import BranchGuide from "./pages/About/BranchGuide";
import ReservationGuide from "./pages/About/ReservationGuide";
import UsageInformation from "./pages/About/UsageInformation";
import DiscountBenefits from "./pages/About/DiscountBenefits";
import TermsOfService from "./pages/About/TermsOfService";
import AuthVerificationResult from "./hooks/AuthVerificationResult";
import PaymentResult from "./services/Payment/PaymentResult";
import { LanguageProvider } from "./hooks/useLanguage";
import { FooterProvider } from "./components/Footer/FooterContext";
import ScrollRestoration from "./components/Scroll/ScrollRestoration"; // 스크롤 위치 저장
import back_button from "./assets/icon/back.svg";

function MainRouter() {
  console.log("Front-end Developer : 권준형, Back-end Developer : 전유민, 최재환, Publishing Developer : 고민채")
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'CINEMA';

  if (type === 'CAMERA') {
    return <CameraMain />;
  }
  if (type === 'CINEMA') {
    return <CinemaMain />;
  }

  return <Navigate to="/main?type=CINEMA" replace />;
}

function App() {
  const [isMobile, setIsMobile] = useState(false); // 모바일 화면 레이아웃 적용

  // 모바일 화면 레이아웃 적용(1280px 이하)
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1280);
    };

    // 초기 상태 설정 추가
    handleResize();
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // 브라우저의 기본 스크롤 복원 비활성화
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  return (
    <LanguageProvider>
        <FooterProvider>
          <div id="App" className="App">
            <div id="view_wrapper">
              <Router>
              <ScrollRestoration />
            <Header/>
            <Routes>
              {/* 메인 페이지 라우트 */}
              {/* <Route path="/" element={<Navigate to="/main?type=CAMERA" replace />} /> */}
              <Route path="/" element={<Navigate to="/main?type=CINEMA" replace />} />
              <Route path="/main" element={<MainRouter />} />
              <Route path="/login" element={<Login />} />
              <Route path="/joinAgreement" element={<JoinAgreement />} />
              <Route path="/auth/find/id" element={<IdFind />} />
              <Route path="/auth/find/password" element={<PassWordFind />} />
              <Route path="/joinVerification" element={<JoinVerification />} />
              <Route path="/joinForm" element={<JoinForm />} />
              <Route path="/joinUser" element={<JoinUser />} />
              <Route path="/joinComplete" element={<JoinComplete />} />
              <Route path="/privacyPolicy" element={<PrivacyPolicy />} />
              <Route path="/mainMore/:type/:currentType" element={<MainMore />} />
              <Route path="/search" element={<SearchPage />} />
              {/* 상품상세페이지 라우트 */}
              <Route path="/product/detail/:goods_seq" element={<PackageDetail />} />
              {/* 카테고리 페이지 라우트 */}
              <Route path="/category/brandPage" element={<BrandPage />} />
              <Route path="/category/brandPage/brandPageSec" element={<BrandPageSec />} />
              <Route path="/category/purpose" element={<Purpose />} />
              <Route path="/category/cinemaPage" element={<CinemaPage />} />
              <Route path="/category/cinemaPageSec" element={<CinemaPageSec />} />
              <Route path="/category/cinemaPageSecDetail" element={<CinemaPageSecDetail />} />
              
              {/* 주문 */}
              <Route path="/order" element={<OrderView />}>
                <Route index element={<Navigate to="visit" replace />} />  {/* /order 접근시 /order/visit로 리다이렉트 */}  
                <Route path="visit" element={<VisitOrder />} />
                <Route path="parcel" element={<ParcelOrder />} />
                <Route path="sale" element={<SaleOrder />} />
              </Route>
              <Route path="/order/quotationForm" element={<QuotationForm />} />
              <Route path="/order/orderComplete/:order_seq" element={<OrderComplete />} />
              <Route path="/order/complete" element={<OrderComplete />} />

              {/* 마이페이지 */}
              <Route path="/myPage" element={<MyPage />}>    
                  <Route index element={<MyOrderList/>}/> {/* 기본 진입 페이지로 MyOrderList 표시 */}
                  <Route path="orderManagement" element={<OrderManagement />} />  {/* useSearchParams */}
                  <Route path="orderManagement/:type" element={<OrderManagement />} />  {/* useParams */}
                  <Route path="order" element={<OrderDetail />} /> 
                  <Route path="orderReturnDetail" element={<OrderReturnDetail />} /> {/* 반품 상세 */}
                  <Route path="orderExchangeDetail" element={<OrderExchangeDetail />} /> {/* 교환 상세 */}
                  <Route path="orderReturnForm" element={<OrderReturnForm />} /> {/* 반품 신청 */}
                  <Route path="orderExchangeForm" element={<OrderExchangeForm />} /> {/* 교환 신청 */}
                  <Route path="deposit" element={<DepositAndPointList type="deposit"/>} />  {/* 예치금 */}
                  <Route path="point" element={<DepositAndPointList type="point"/>} />  {/* 포인트 */}
                  <Route path="deposit/charge" element={<DepositCharge />} />  {/* 예치금 충전 */}
                  <Route path="deposit/refund" element={<DepositRefund />} />  {/* 예치금 환불 */}
                  <Route path="coupon" element={<CouponList />} />  {/* 쿠폰 */}
                  <Route path="wishList" element={<WishList />} />  {/* 관심상품 */}

                  <Route path="support" element={<InquiryList inquiryType="support"/>} />  {/* 제작지원 */}
                  <Route path="inquiry" element={<InquiryList inquiryType="inquiry"/>} />  {/* 1:1 문의 */}
                  <Route path="customizing" element={<InquiryList inquiryType="customizing"/>} />  {/* 커스터마이징 */}
                  <Route path="priceGuarantee" element={<InquiryList inquiryType="priceGuarantee"/>} />  {/* 최저가 보장 */}
                  <Route path="support/:b_seq" element={<InquiryDetail inquiryType="support"/>} />  {/* 제작지원 상세*/}
                  <Route path="inquiry/:b_seq" element={<InquiryDetail inquiryType="inquiry"/>} />  {/* 1:1 문의 상세 */}
                  <Route path="customizing/:b_seq" element={<InquiryDetail inquiryType="customizing"/>} />  {/* 커스터마이징 상세 */}
                  <Route path="priceGuarantee/:b_seq" element={<InquiryDetail inquiryType="priceGuarantee"/>} />  {/* 최저가 보장 상세 */}

                  <Route path="delivery" element={<DeliveryAddrList />} />  {/* 배송주소록 관리 */}
                  <Route path="delivery/register" element={<RegisterDeliveryAddr />} />  {/* 배송주소록 등록 */}
                  <Route path="profile/edit" element={<EditProfile />} />  {/* 배송주소록 등록 */}

              </Route>
              <Route path="/myPage/orderExtension/:type" element={<OrderExtension />} />   {/* 연장신청 */}
        
              {/* 커뮤니티 */}
              <Route path="/community" element={<Community/>}>
                <Route index element={<Navigate to="notice" replace />} />  {/* /community 접근시 /community/notice로 리다이렉트 */}  
                <Route path="notice" element={< NoticeList/>} />   
                <Route path="notice/:b_seq" element={< NoticeDetail/>} />   
                <Route path="event" element={< EventList/>} />   
                <Route path="faq" element={< FaqList/>} />   
                <Route path="inquiry" element={< CommInquiryList/>} />   
                <Route path="inquiry/write" element={< CommInquiryForm/>} />   
                <Route path="inquiry/detail/:b_seq" element={< CommInquiryDetail/>} />   
                <Route path="customizing" element={< CustomizingList/>} />   
                <Route path="customizing/write" element={< CustomizingForm/>} />   
                <Route path="customizing/detail/:b_seq" element={< CustomizingDetail/>} />   
                <Route path="support" element={< SupportList/>} />   
                <Route path="support/write" element={< SupportForm/>} />   
                <Route path="priceGuarantee" element={< PriceGuarantee/>} />   
                <Route path="priceGuarantee/write" element={< PriceGuaranteeForm/>} />   
                <Route path="credit" element={< CreditList/>} />   
              </Route>

              {/* 회사소개 */}
              <Route path='/about' element={<About />}>
                <Route index element={<Navigate to="intro" replace />} />  {/* /about 접근시 /about/intro 로 리다이렉트 */}  
                <Route path="intro" element={< CompanyIntro/>} />   
                <Route path="history" element={< CompanyHistory/>} />   
                <Route path="branch" element={< BranchGuide/>} />   
                <Route path="guide" element={< ReservationGuide/>} />   
                <Route path="information" element={< UsageInformation/>} />   
                <Route path="terms" element={< TermsOfService/>} />   
                <Route path="benefits" element={< DiscountBenefits/>} />  
              </Route>
              <Route path="/auth/verification/result" element={<AuthVerificationResult />} />
              <Route path="/payment/result" element={<PaymentResult />} />
            </Routes>
            <FloatingNavigation />
            {/* 모바일에서만 뒤로가기 버튼 노출 (메인 페이지 제외) */}
            {isMobile && (
              <BackButtonWrapper />
            )}
            <Footer/>
          </Router>
        </div>
      </div>
      </FooterProvider>
    </LanguageProvider>
  );
}

// 간단한 조건부 렌더링 컴포넌트
function BackButtonWrapper() {
  const location = useLocation();
  
  // 메인 페이지에서는 보이지 않도록
  if (location.pathname === '/main' || location.pathname === '/') {
    return null;
  }

  return (
    <div className="back_button" style={{paddingLeft: '10px'}} onClick={() => window.history.back()}>
      <img src={back_button} alt="뒤로가기" />
    </div>
  );
}

export default App;
